import { useMemo } from 'react';

const NUMBER_OF_TICKS = 5;

export default function useBarChart(
  values: number[],
  numberOfTicks = NUMBER_OF_TICKS,
) {
  return useMemo(() => {
    const maxValue = Math.max(...values) || 1;

    const increment = Math.floor(maxValue / (numberOfTicks - 1)) || 1;

    const gridYValues = Array.from(
      { length: numberOfTicks },
      (_, i) => i * increment,
    );

    return {
      gridYValues,
    };
  }, [values, numberOfTicks]);
}
